// extracted by mini-css-extract-plugin
module.exports = {"item":"styles_item__28FgR","icon":"styles_icon__1usWS","label":"styles_label__VSDtz"};